export const PREVIOUSLY_SELECTED_SEARCH_UNIVERSE = "previouslySelectedSearchUniverse";

export function previouslySelectedSearchUniverse(defaultSearchUniverse) {
    const selectedSearchUniverse = global.window.localStorage.getItem(PREVIOUSLY_SELECTED_SEARCH_UNIVERSE);

    return selectedSearchUniverse ? selectedSearchUniverse : defaultSearchUniverse;
}

export function saveSelectedSearchUniverse(searchUniverse) {
    if (localStorageAvailable()) {
        global.window.localStorage.setItem(PREVIOUSLY_SELECTED_SEARCH_UNIVERSE, searchUniverse);
    }
}

function localStorageAvailable() {
    try {
        var storage = window.localStorage,
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return false;
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/selectedSearchUniverseStorage.js
 **/